// import React, { useEffect, useMemo, useState } from "react";
// import { RefreshCcw, Pencil, CheckCircle2, X } from "lucide-react";
// import axios from "axios";
// import ToastContainer from "../../Utils/ToastContainer";
// import { toast } from "react-toastify";

// // ---- Static Plans (as provided) ----
// const plans = [
//     { pk_plan_id: 1, plan_name: "Basic", plan_price: 1999, plan_duration: "Monthly", country_code: "IN", currency: "INR", is_active: 1, sequence: 2 },
//     { pk_plan_id: 2, plan_name: "Standard", plan_price: 2999, plan_duration: "Monthly", country_code: "IN", currency: "INR", is_active: 1, sequence: 3 },
//     { pk_plan_id: 3, plan_name: "Premium", plan_price: 3999, plan_duration: "Monthly", country_code: "IN", currency: "INR", is_active: 1, sequence: 4 },
//     { pk_plan_id: 4, plan_name: "Trial", plan_price: 0, plan_duration: "For 15 Days", country_code: "IN", currency: "INR", is_active: 0, sequence: 1 },
//     { pk_plan_id: 5, plan_name: "Basic", plan_price: 40, plan_duration: "Monthly", country_code: "US", currency: "USD", is_active: 1, sequence: 2 },
//     { pk_plan_id: 6, plan_name: "Standard", plan_price: 75, plan_duration: "Monthly", country_code: "US", currency: "USD", is_active: 1, sequence: 3 },
//     { pk_plan_id: 7, plan_name: "Premium", plan_price: 140, plan_duration: "Monthly", country_code: "US", currency: "USD", is_active: 1, sequence: 4 },
//     { pk_plan_id: 8, plan_name: "Trial", plan_price: 0, plan_duration: "For 15 Days", country_code: "US", currency: "USD", is_active: 0, sequence: 1 },
// ];

// const AdminSubscriptionManagement = ({ user }) => {
//     const [currentPlan, setCurrentPlan] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [changing, setChanging] = useState(false);
//     const [selectedPlan, setSelectedPlan] = useState(null);
//     const [open, setOpen] = useState(false);

//     const userCountry = user?.country_code || "IN";

//     const availablePlans = useMemo(() => {
//         return plans
//             .filter((p) => p.country_code === userCountry && p.is_active === 1)
//             .sort((a, b) => a.sequence - b.sequence);
//     }, [userCountry]);

//     const fetchCurrentPlan = async () => {
//         try {
//             setLoading(true);
//             const { data } = await axios.post(
//                 "https://remittpe.com/api/Admin/v1.0/getSubscriptionPlan",
//                 { userId: user.userId }
//             );
//             setCurrentPlan(data?.response || null);
//         } catch (e) {
//             toast.error("Failed to fetch current plan");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const changePlan = async () => {
//         if (!selectedPlan) return;
//         try {
//             setChanging(true);
//             await axios.post(
//                 "https://remittpe.com/api/Admin/v1.0/changeSubscriptionPlan",
//                 {
//                     userid: user.userId,
//                     planId: selectedPlan.pk_plan_id,
//                 }
//             );
//             toast.success("Subscription plan updated successfully");
//             setOpen(false);
//             fetchCurrentPlan();
//         } catch (e) {
//             toast.error("Failed to change subscription plan");
//         } finally {
//             setChanging(false);
//         }
//     };

//     useEffect(() => {
//         if (user?.userId) fetchCurrentPlan();
//     }, [user?.userId]);

//     return (
//         <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
//             <ToastContainer />

//             {/* Header */}
//             <div className="flex items-center justify-between">
//                 <div>
//                     <h3 className="text-sm font-semibold text-gray-900">Subscription</h3>
//                     <p className="text-xs text-gray-500">Manage client subscription plan</p>
//                 </div>
//                 <button
//                     onClick={fetchCurrentPlan}
//                     className="inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs hover:bg-slate-50"
//                 >
//                     <RefreshCcw className={`h-3.5 w-3.5 ${loading ? "animate-spin" : ""}`} />
//                     Refresh
//                 </button>
//             </div>

//             {/* Current Plan */}
//             <div className="mt-4 rounded-lg border bg-slate-50 p-3">
//                 <div className="flex items-center justify-between">
//                     <div>
//                         <p className="text-[11px] text-gray-500">Current Plan</p>
//                         <p className="text-sm font-semibold text-gray-900">
//                             {currentPlan?.plan_name || "—"}
//                         </p>
//                         <p className="text-[11px] text-gray-600">
//                             {currentPlan?.currency} {currentPlan?.plan_price} · {currentPlan?.plan_duration}
//                         </p>
//                     </div>
//                     <button
//                         onClick={() => setOpen(true)}
//                         className="inline-flex items-center gap-1 rounded-md bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-emerald-700"
//                     >
//                         <Pencil className="h-3.5 w-3.5" />
//                         Change Plan
//                     </button>
//                 </div>
//             </div>

//             {/* Change Plan Modal */}
//             {open && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
//                     <div className="w-full max-w-3xl rounded-xl bg-white p-5 shadow-lg">
//                         <div className="mb-3 flex items-center justify-between">
//                             <h4 className="text-sm font-semibold">Change Subscription Plan</h4>
//                             <button onClick={() => setOpen(false)}>
//                                 <X className="h-4 w-4" />
//                             </button>
//                         </div>

//                         <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
//                             {availablePlans.map((p) => {
//                                 const active = selectedPlan?.pk_plan_id === p.pk_plan_id;
//                                 return (
//                                     <button
//                                         key={p.pk_plan_id}
//                                         onClick={() => setSelectedPlan(p)}
//                                         className={`rounded-lg border p-3 text-left transition ${active
//                                                 ? "border-emerald-600 bg-emerald-50"
//                                                 : "hover:border-slate-300"
//                                             }`}
//                                     >
//                                         <p className="text-sm font-semibold">{p.plan_name}</p>
//                                         <p className="text-xs text-gray-500">{p.plan_duration}</p>
//                                         <p className="mt-1 text-xs font-medium">
//                                             {p.currency} {p.plan_price}
//                                         </p>
//                                     </button>
//                                 );
//                             })}
//                         </div>

//                         <div className="mt-4 flex justify-end gap-2">
//                             <button
//                                 onClick={() => setOpen(false)}
//                                 className="rounded-md border px-3 py-1.5 text-xs"
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 disabled={!selectedPlan || changing}
//                                 onClick={changePlan}
//                                 className="inline-flex items-center gap-1 rounded-md bg-emerald-600 px-4 py-1.5 text-xs font-semibold text-white disabled:opacity-50"
//                             >
//                                 <CheckCircle2 className="h-3.5 w-3.5" />
//                                 {changing ? "Updating..." : "Confirm Change"}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AdminSubscriptionManagement;

import React, { useContext, useMemo, useState } from "react";
import { Search, X } from "lucide-react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";
import useSuperAdmin from "../Services/SuperAdminServices/useSuperAdmin";

const plans = [
  {
    pk_plan_id: 1,
    plan_name: "Basic",
    plan_price: 1999,
    plan_duration: "Monthly",
    country_code: "IN",
    currency: "INR",
    is_active: 1,
    sequence: 2,
  },
  {
    pk_plan_id: 2,
    plan_name: "Standard",
    plan_price: 2999,
    plan_duration: "Monthly",
    country_code: "IN",
    currency: "INR",
    is_active: 1,
    sequence: 3,
  },
  {
    pk_plan_id: 3,
    plan_name: "Premium",
    plan_price: 3999,
    plan_duration: "Monthly",
    country_code: "IN",
    currency: "INR",
    is_active: 1,
    sequence: 4,
  },
  {
    pk_plan_id: 4,
    plan_name: "Trial",
    plan_price: 0,
    plan_duration: "For 15 Days",
    country_code: "IN",
    currency: "INR",
    is_active: 0,
    sequence: 1,
  },
  {
    pk_plan_id: 5,
    plan_name: "Basic",
    plan_price: 40,
    plan_duration: "Monthly",
    country_code: "US",
    currency: "USD",
    is_active: 1,
    sequence: 2,
  },
  {
    pk_plan_id: 6,
    plan_name: "Standard",
    plan_price: 75,
    plan_duration: "Monthly",
    country_code: "US",
    currency: "USD",
    is_active: 1,
    sequence: 3,
  },
  {
    pk_plan_id: 7,
    plan_name: "Premium",
    plan_price: 140,
    plan_duration: "Monthly",
    country_code: "US",
    currency: "USD",
    is_active: 1,
    sequence: 4,
  },
  {
    pk_plan_id: 8,
    plan_name: "Trial",
    plan_price: 0,
    plan_duration: "For 15 Days",
    country_code: "US",
    currency: "USD",
    is_active: 0,
    sequence: 1,
  },
];

const AdminSubscriptionManagement = () => {
  const { getSubscriptionPlan, changeSubscriptionPlan } = useSuperAdmin();
  const { AllClients, adminId } = useContext(GlobalContext);

  const [open, setOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const clients = Array.isArray(AllClients) ? AllClients : [];

  const normalizeText = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase();

  const normalizeContact = (value) => String(value ?? "").replace(/\D/g, "");

  const getClientId = (client) =>
    client?.us_code ??
    client?.user_code ??
    client?.userid ??
    client?.userId ??
    client?.user_id ??
    client?.client_id ??
    client?.clientId ??
    "";

  const getUserName = (client) =>
    client?.us_name ??
    client?.user_name ??
    client?.username ??
    client?.organization_name ??
    client?.name ??
    "";

  const getContact = (client) =>
    client?.us_loginid ??
    client?.contact ??
    client?.contact_number ??
    client?.mobile ??
    client?.phone_no ??
    client?.phone ??
    "";

  const filteredClients = useMemo(() => {
    const query = normalizeText(searchQuery);
    const contactQuery = normalizeContact(searchQuery);

    if (!query) {
      return clients;
    }

    /*
      Priority 1:
      Client ID ka exact match milne par sirf wahi client show hoga.
      Example: A1001 => only A1001.
    */
    const exactClientIdMatches = clients.filter(
      (client) => normalizeText(getClientId(client)) === query,
    );

    if (exactClientIdMatches.length > 0) {
      return exactClientIdMatches;
    }

    /*
      Priority 2:
      Username aur mobile/contact par partial search.
      Example: 99, 9910, 4756 ya username ka kuch part.
    */
    return clients.filter((client) => {
      const clientId = normalizeText(getClientId(client));
      const userName = normalizeText(getUserName(client));
      const contactText = normalizeText(getContact(client));
      const contactNumber = normalizeContact(getContact(client));

      return (
        clientId.includes(query) ||
        userName.includes(query) ||
        contactText.includes(query) ||
        (contactQuery.length > 0 && contactNumber.includes(contactQuery))
      );
    });
  }, [clients, searchQuery]);

  const fetchCurrentPlan = async (client) => {
    const clientId = getClientId(client);

    if (!clientId) return;

    try {
      const result = await getSubscriptionPlan({
        adminId,
        userid: clientId,
      });

      if (result.success) {
        setCurrentPlan(result.data);
      } else {
        setCurrentPlan(null);
      }
    } catch (err) {
      console.error("Fetch current plan error:", err);
      setCurrentPlan(null);
    }
  };

  const openModal = async (client) => {
    setSelectedClient(client);
    setSelectedPlan(null);
    setCurrentPlan(null);
    setOpen(true);

    await fetchCurrentPlan(client);
  };

  const closeModal = () => {
    setOpen(false);
    setSelectedClient(null);
    setSelectedPlan(null);
    setCurrentPlan(null);
  };

  const changePlan = async () => {
    if (!selectedPlan || !selectedClient) return;

    setLoading(true);

    try {
      const result = await changeSubscriptionPlan({
        userid: getClientId(selectedClient),
        planId: selectedPlan.pk_plan_id,
      });

      if (result.success) {
        toast.success(result.message);
        await fetchCurrentPlan(selectedClient);
        setSelectedPlan(null);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error("Change subscription error:", err);
      toast.error("Change subscription API failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* CLIENT LIST */}
      <div className="overflow-hidden rounded-xl border bg-white">
        {/* SEARCH BAR */}
        <div className="flex flex-col gap-3 border-b bg-white p-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="relative w-full sm:max-w-md">
            <Search
              size={17}
              className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
              type="text"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
              placeholder="Search by Client ID, User Name or Contact"
              className="h-10 w-full rounded-lg border border-gray-300 bg-white pl-10 pr-10 text-sm text-gray-800 outline-none transition placeholder:text-gray-400 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100"
            />

            {searchQuery && (
              <button
                type="button"
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-0.5 text-gray-400 transition hover:bg-gray-100 hover:text-gray-700"
                aria-label="Clear search"
              >
                <X size={16} />
              </button>
            )}
          </div>

          <p className="whitespace-nowrap text-xs font-medium text-gray-500">
            Showing {filteredClients.length} of {clients.length} clients
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] text-sm">
            <thead className="bg-emerald-50">
              <tr>
                <th className="p-2 text-left">Serial No</th>
                <th className="p-2 text-left">Client ID</th>
                <th className="p-2 text-left">User Name</th>
                <th className="p-2 text-left">Contact</th>
                <th className="p-2 text-left">Status</th>
                <th className="p-2">Action</th>
              </tr>
            </thead>

            <tbody key={normalizeText(searchQuery) || "all-clients"}>
              {filteredClients.map((client, index) => {
                const clientId = getClientId(client);
                const userName = getUserName(client);
                const contact = getContact(client);

                const uniqueRowKey = [
                  clientId,
                  userName,
                  contact,
                  client?.id,
                  client?.pk_user_id,
                  index,
                ]
                  .filter((value) => value !== undefined && value !== null)
                  .join("-");

                return (
                  <tr key={uniqueRowKey} className="border-t">
                    <td className="p-2">{index + 1}</td>
                    <td className="p-2">{clientId || "—"}</td>
                    <td className="p-2">{userName || "—"}</td>
                    <td className="p-2">{contact || "—"}</td>
                    <td className="p-2">
                      <span
                        className={`inline-flex items-center gap-2 rounded-full px-2 py-1 text-xs font-semibold ${
                          client.us_status === "1"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        <span
                          className={`h-2 w-2 rounded-full ${
                            client.us_status === "1"
                              ? "bg-green-600"
                              : "bg-red-600"
                          }`}
                        />

                        {client.us_status === "1" ? "Active" : "Inactive"}
                      </span>
                    </td>

                    <td className="p-2 text-center">
                      <button
                        type="button"
                        className="rounded bg-emerald-600 px-3 py-1 text-xs text-white transition hover:bg-emerald-700"
                        onClick={() => openModal(client)}
                      >
                        Manage Plan
                      </button>
                    </td>
                  </tr>
                );
              })}

              {!filteredClients.length && (
                <tr>
                  <td colSpan={6} className="p-6 text-center text-gray-500">
                    {searchQuery.trim()
                      ? "No client matches your search"
                      : "No clients found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="max-h-[90vh] w-full max-w-[900px] overflow-y-auto rounded-xl bg-white p-4">
            <div className="mb-3 flex items-center justify-between">
              <h2 className="text-sm font-semibold">
                Subscription –{" "}
                {selectedClient?.organization_name || selectedClient?.us_name}
              </h2>

              <button
                type="button"
                onClick={closeModal}
                className="rounded p-1 transition hover:bg-gray-100"
                aria-label="Close modal"
              >
                <X size={16} />
              </button>
            </div>

            {/* CURRENT PLAN */}
            {currentPlan?.plan_name && (
              <div className="mb-4 rounded border bg-emerald-50 p-3 text-sm">
                <div className="font-semibold text-gray-700">
                  Current Subscription
                </div>

                <div className="mt-1 font-bold text-emerald-700">
                  {currentPlan.plan_name}
                </div>

                <div className="mt-1 text-xs text-gray-600">
                  {currentPlan.billing_cycle} · Remaining{" "}
                  {currentPlan.remaining_days} days
                </div>
              </div>
            )}

            {/* PLANS TABLE */}
            <div className="overflow-x-auto">
              <table className="w-full min-w-[650px] border text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border p-2">Plan</th>
                    <th className="border p-2">Price</th>
                    <th className="border p-2">Duration</th>
                    <th className="border p-2">Country</th>
                    <th className="border p-2">Select</th>
                  </tr>
                </thead>

                <tbody>
                  {plans
                    .filter((plan) => plan.is_active)
                    .map((plan) => (
                      <tr key={plan.pk_plan_id}>
                        <td className="border p-2">{plan.plan_name}</td>
                        <td className="border p-2">
                          {plan.currency} {plan.plan_price}
                        </td>
                        <td className="border p-2">{plan.plan_duration}</td>
                        <td className="border p-2">{plan.country_code}</td>
                        <td className="border p-2 text-center">
                          <input
                            type="radio"
                            name="plan"
                            checked={
                              selectedPlan?.pk_plan_id === plan.pk_plan_id
                            }
                            onChange={() => setSelectedPlan(plan)}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="mt-4 flex justify-end gap-2">
              <button
                type="button"
                className="rounded border px-3 py-1 text-xs"
                onClick={closeModal}
              >
                Cancel
              </button>

              <button
                type="button"
                disabled={!selectedPlan || loading}
                onClick={changePlan}
                className="rounded bg-emerald-600 px-4 py-1 text-xs text-white disabled:cursor-not-allowed disabled:opacity-50"
              >
                {loading ? "Updating..." : "Update Plan"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminSubscriptionManagement;



